@if (ticket()?.nextSteps?.length === 0) {
  <div class="flex flex-row justify-center mt-6">
    {{ '#TICKETS.DIALOGS.NEXT_STEP.NO_STEPS' | translate }}
  </div>
}
@if ((ticket()?.nextSteps?.length ?? 0) > 0) {
  @if ((step$ | async) === undefined) {
    <soft-radio-group
      (valueChange)="onSelectStep($event)"
      class="flex flex-col"
      #radio="softRadioGroup"
    >
      @for (step of ticket()?.nextSteps; track step) {
        <soft-radio-option [value]="step">
          <span class="soft-label right">{{ step }}</span>
        </soft-radio-option>
      }
    </soft-radio-group>
  }
  @if (step$ | async; as step) {
    <div class="flex flex-col mt-4">
      <div class="soft-label top">
        {{ '#TICKETS.DIALOGS.NEXT_STEP.STEP' | translate }}
      </div>
      <div class="flex flex-row items-center gap-2 auto-width">
        {{ step$ | async }}
        <div
          softToolTip="Status ändern"
          class="text-primary bg-primary-50 rounded-full p-3 cursor-pointer hover:bg-hover"
          (click)="onRemoveStep()"
        >
          <soft-icon name="fa-regular fa-pen-to-square"></soft-icon>
        </div>
      </div>
    </div>
    @if (loading$ | async) {
      <soft-loading-spinner></soft-loading-spinner>
    }
    @if (definition$ | async; as definition) {
      <div class="flex flex-col">
        <soft-dynamic-form
          class="flex flex-row"
          [value]="ticket"
          [definition]="$any(definition)"
          (valueChange)="ticketChanges = $event"
          #dynamicForm
        ></soft-dynamic-form>
        <div class="flex flex-row justify-end">
          <button
            class="soft-button primary mt-2"
            [disabled]="dynamicForm.form().invalid"
            (click)="onSubmit(step, dynamicForm.form().value)"
          >
            {{ '#TICKETS.DIALOGS.NEXT_STEP.SUBMIT' | translate }}
          </button>
        </div>
      </div>
    }
    @if ((definition$ | async) === null) {
      <div class="flex flex-row justify-end">
        <button
          class="soft-button primary rounded hover:cursor-pointer"
          [disabled]="!step"
          (click)="onSubmit(step)"
        >
          {{ '#TICKETS.DIALOGS.NEXT_STEP.SUBMIT' | translate }}
        </button>
      </div>
    }
  }
}
